// Types
import type { Routes, Route } from '@angular/router';

export interface NavItem {
  path: string;
  label: string;
  category?: string;
  icon?: string;
  children?: NavItem[];
  displayInMenu?: boolean;
}

export const getNavItems = (routes: Routes, parentPath = ''): NavItem[] => {
  let navItems: NavItem[] = [];

  routes.forEach((route: Route) => {
    const fullPath = parentPath ? `${parentPath}/${route.path}` : (route.path as string);
    const navItem: NavItem = {
      path: fullPath,
      label: route?.title ?? route?.data?.['menuTitle'] ?? '',
      ...(route?.data?.['category'] && { category: route?.data?.['category'] }),
      ...(route?.data?.['icon'] && { icon: route?.data?.['icon'] }),
      displayInMenu: route?.data?.['displayInMenu'],
    };

    // If there are children, recursively process them
    let childRoutes: NavItem[] = [];
    if (route.children) {
      childRoutes = getNavItems(route.children, fullPath);
    }

    navItems = [...navItems, navItem, ...childRoutes];
  });

  return navItems.filter(({ displayInMenu }) => !!displayInMenu);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const groupByCategory = (navItems: any[]) =>
  navItems.reduce((acc, item) => {
    if (item.category) {
      const category = item.category;

      if (!acc[category]) {
        acc[category] = [];
      }

      acc[category].push(item);
    }
    return acc;
  }, {});
